import React from 'react';
import PropTypes from 'prop-types';

import { isSubscribed } from '../../user/userUtil';
import { isStaff } from '../../../common/users/utils/userPropertyUtils';

import ProBadge from './ProBadge';
import Badge from '../misc/Badge';

const UserPlanBadge = ({ user }) => {
    if (isStaff(user)) return <Badge className="ProBadge">Staff</Badge>;
    if (!isSubscribed(user)) return null;

    return <ProBadge />;
};

UserPlanBadge.propTypes = {
    user: PropTypes.object,
};

export default UserPlanBadge;
